import React from 'react';
import { observer } from 'mobx-react-lite';

const Main = observer(
  ({ t, activeFreeBet, mainMarketsData, selectedMarket, setSelectedMarket }) => {
    return (
      <div className='mob-game-btn-block-main'>
        {mainMarketsData.map((mainBetType) => {
          return (
            <div
              key={mainBetType.marketType}
              className={`block-main-row type${mainBetType.styleId} ${
                selectedMarket.marketType === mainBetType.marketType ? 'active' : ''
              } ${activeFreeBet.id && activeFreeBet.minOdd > mainBetType.odd ? 'disabled' : ''}`}
              onClick={() => setSelectedMarket({ ...mainBetType, hiOrLo: null })}
            >
              <p className='block-main-row-text'>{t(mainBetType.betType)}</p>
              <p className='block-main-row-number'>x{mainBetType.odd}</p>
            </div>
          );
        })}
      </div>
    );
  }
);

export default Main;
